/**
 * Returns true if the value is a number that can be compared to other numbers. This excludes `NaN`
 * but not `Infinity`.
 */
export function isComparableNumber(value: unknown): value is number {
	// `value >= value` weeds out corner cases like if `value` is `NaN`, though notably *NOT* if the
	// value is `Infinity`.
	return typeof value === "number" && value >= value;
}

export function round(num: number, numDecimals = 2) {
	const factor = Math.pow(10, numDecimals);
	return Math.round(num * factor) / factor;
}
